module.exports = __webpack_public_path__ + "static/media/family.1547507d.svg";